<template>
  <div class="">
    <Header ref="child" class="fixhead" />
    <div @mouseover="sendData">
      <Content style="padding-top: 138px;" />
      <Footer style="margin-top: 60px;" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Content from "@/components/Content.vue";
import Footer from "@/components/Footer.vue";
import imgPrefix from "../../../utils/imgPrefix";
export default {
  components: { Footer, Header, Content },
  data() {
    return {imgPrefix};
  },
  created(){
    let findTopBar = JSON.parse(sessionStorage.getItem("findTopBar"));
    // 改变主题颜色
    const bodyStyle = document.getElementsByTagName("body")[0].style;
      bodyStyle.setProperty("--themeColor", findTopBar.topicColor);
      // 改变网站图标
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = this.imgPrefix + findTopBar.webInco;
      document.getElementsByTagName("head")[0].appendChild(link);
  },
  methods:{
    sendData() {
      // console.log('-------------',this.$refs.child);
      this.$refs.child.ifShowDept=false
    }
  }
};
</script>

<style lang="less" scoped>
.fixhead{
  position: fixed;
  background: #fff;
  z-index: 999;
  width: 100%;
}
</style>
